import { Shark } from "shark-mvc";
import EXIF from "exif-js";

import ContentViewBase from "../ContentViewBase";
import ImageContent from "../../models/ImageContent";
import ImageExifData from "../../models/ImageExifData";

import templateContent from "./image-content.html";

import contentFinderComponent from "../../components/contentFinder/contentFinderComponent";
import dashboardView from "../dashboard/dashboardView";
import imageContentManager from "../../controllers/imageContentManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import customTagsComponent from "../../components/customTags/customTagsComponent";
import autoRelatedContentSuggestionComponent from "../../components/autoRelatedContentSuggestion/autoRelatedContentSuggestionComponent";
import userMetadataBoxComponent from "../../components/userMetadataBox/userMetadataBoxComponent";

class ImageContentView extends ContentViewBase {
	constructor () {
		super("imageContentView");
		this.setTemplate(templateContent);
	}

	// Dave: Questa mi serve perché se lo chiamo da qui, succede prima del "super.beforeLoad", se no succede dopo... e si incasina.
	afterLoad () {
		super.afterLoadCommon(true);

		const { currContent } = Shark.get();

		if (currContent) {
			this.setupEditor();
		}
		if (!this.tagProcessed) {
			this.processTags();
		}
	}

	beforeLoad () {
		this.tagProcessed = false;
		super.beforeLoad(imageContentManager, ImageContent);
	}

	// Dave: Questo non servirebbe, ma c'è il problema del giro di precedenze come per l'afterLoad...
	contentLoaded () {
		// Shark.render();
		this.setupEditor();
		waitBoxComponent.close();
	}

	copySelectionToTitleBtn_clickHandler () {
		const title = Shark.$store.__contentViewTinymceEditor.selection.getContent({ format: "text" });

		Shark.$store.currContent.set({
			title,
		});
	}

	deleteCurrContentImage () {
		if (confirm("Sei sicuro di voler cancellare l'immagine?\nNon verrà eliminato il contenuto, ma solo l'immagine associata.")) {
			Shark.$store.currContent.set({
				fileURL: "",
				fileThumbnailURL: "",
			});
			Shark.render();
		}
	}

	deleteCurrContentImageBtn_clickHandler () {
		this.deleteCurrContentImage();
	}

	deleteContent (guid) {
		waitBoxComponent.open();

		imageContentManager.delete({guid})
		.then(() => {
			waitBoxComponent.close();
			Shark.openPage(dashboardView, { urlSearchParams: null });
		});
	}

	async getExifData (file) {
		const currContent = await imageContentManager.extractAndAddImageAndExifData(file, Shark.$store.currContent);

		Shark.set({
			currContent,
		});

		Shark.$store.__contentViewTinymceEditor.setContent(currContent.description);

		Shark.render();

		// EXIF.getData(file, () => {
		// 	var make = EXIF.getTag(file, "Make");
		// 	var model = EXIF.getTag(file, "Model");
			
		// 	console.log({make, model, exifdata: file.exifdata, file});

		// 	const exifData = new ImageExifData(file.exifdata);
		// 	exifData.rawData = file;
		// 	console.log({exifData});
			
		// 	Shark.$store.__contentViewTinymceEditor.setContent(exifData.ImageDescription);

		// 	Shark.$store.currContent.set({
		// 		authorName: exifData.Artist,
		// 		copyright: exifData.Copyright,
		// 		__exifCreationDate: exifData.DateTime,
		// 		description: exifData.ImageDescription,
		// 		fileType: exifData.MimeType,
		// 		source: imageContentManager.extractSource(exifData.Copyright),
		// 		originalExifData: exifData || {},
		// 		originalImageInfo: {
		// 			authorName: exifData.Artist,
		// 		},
		// 	});

		// 	Shark.render();
		// 	console.log({ currContent: Shark.$store.currContent , currContentExport: Shark.$store.currContent.export()});

		// });
		// const { currContent } = Shark.get();

		// if (currContent) {
		// 	waitBoxComponent.open();

		// 	imageContentManager.getExifData(currContent)
		// 	.then(response => {
		// 		console.log({response});
		// 		const exifData = new ImageExifData(response.data?.[0]?.data);


		// 		currContent.set({
		// 			authorName: exifData.Artist,
		// 			copyright: exifData.Copyright,
		// 			__exifCreationDate: exifData.DateTime,
		// 			description: exifData.ImageDescription,
		// 			fileType: exifData.MimeType,
		// 		});

		// 		console.log({response, exifData, currContent});

		// 		waitBoxComponent.close();
		// 		Shark.render();
		// 	});
		// }
	}

	getExifDataBtn_clickHandler () {
		this.getExifData();
	}

	init () {
		this.addComponents([autoRelatedContentSuggestionComponent, contentFinderComponent, customTagsComponent, mainNavComponent, userMetadataBoxComponent, waitBoxComponent]);
		super.init();

		Shark.set({
			suggestImagePermissionBtnCSSClasses: "btn-primary",
		});
	}

	async saveCurrContent () {
		await this.save();

		if (Shark.$store.editContentGoBackPage) {
			Shark.openPage(Shark.$store.editContentGoBackPage);
		}
		else {
			Shark.openPage(dashboardView);
		}
	}

	async saveCurrContentAndCreateNew () {
		await this.save();

		const referenceVolumes = Shark.$store.currContent.referenceVolumes;
		
		Shark.set({
			currContent: new ImageContent({
				createdByGuid: Shark.$store.currUser.guid,
				referenceVolumes,
			}),
			isCreatingNewContent: true,
		});
		Shark.openPage(imageContentView, { urlSearchParams: null });
	}

	async save () {
		const { currContent } = Shark.get();

		if (currContent) {
			waitBoxComponent.open();
			
			currContent.set({
				[currContent._mainEditorField]: Shark.$store.__contentViewTinymceEditor.getContent(),
			});

			imageContentManager.save(currContent)
			.then(async saveResponse => {
				console.log({saveResponse});

				const customTagSaveResult = await customTagsComponent.save();
				console.log({customTagSaveResult});

				waitBoxComponent.close();
			});
		}
	}
	
	suggestImagePermission () {
		const { currContent } = Shark.get();

		if (currContent) {
			const contentIsUpdated = imageContentManager.extractAndSetImagePermissionsFromSource(currContent);

			if (contentIsUpdated) {
				Shark.set({
					currContent,
				});
				Shark.render(); //questo non serve, ma c'è un bug in Shark

				Shark.$store.suggestImagePermissionBtnCSSClasses = "btn-success";
			}
			else {
				Shark.$store.suggestImagePermissionBtnCSSClasses = "btn-danger";
			}

			setTimeout(() => {
				Shark.$store.suggestImagePermissionBtnCSSClasses = "btn-primary";
			}, 1000);
		}
	}

	suggestImagePermissionBtn_clickHandler () {
		this.suggestImagePermission();
	}

	uploadField_changeHandler (event) {
		const file = event.target.files[0];

		if (file) {
			const img = document.createElement("img");
			img.src = URL.createObjectURL(file);
			
			img.addEventListener("load", event => {
				console.log({img, height: img.naturalHeight, width: img.naturalWidth });

				// Shark.$store.currContent.set({
				// 	fileIntrinsicHeight: img.naturalHeight,
				// 	fileIntrinsicWidth: img.naturalWidth,
				// });

				this.getExifData(file);
			});
		}
		//this.uploadFile(event.target);
	}
	
	uploadFile (inputField) {
		if (inputField.files.length === 1) {
			waitBoxComponent.open();

			imageContentManager.upload(inputField)
			.then(uploadResponse => {
				console.log({uploadResponse});

				if (uploadResponse.status === "ok") {
					const currImage = uploadResponse.data[0];
					const exifData = new ImageExifData(currImage.exif);

					Shark.$store.currContent.set({
						authorName: exifData.Artist,
						copyright: exifData.Copyright,
						__exifCreationDate: exifData.DateTime,
						description: exifData.ImageDescription,
						fileType: exifData.MimeType,

						fileByteSize: currImage?.mainResizeResult?.fileSize || currImage.size,
						fileIntrinsicHeight: currImage?.resizedImageInfo?.height || currImage.imageInfo.height,
						fileIntrinsicWidth: currImage?.resizedImageInfo?.width || currImage.imageInfo.width,
						fileThumbnailURL: currImage.thumbnailPath,
						// fileType: currImage.imageInfo.mime,
						fileURL: currImage.filePath,
						source: imageContentManager.extractSource(exifData.Copyright),
						originalExifData: exifData || {},
						originalFileName: currImage.name,
						originalImageInfo: {
							authorName: exifData.Artist,
							fileByteSize: currImage.size,
							height: currImage.imageInfo.height,
							width: currImage.imageInfo.width,
						},
					});
				}
				else {
					alert("Attenzione, si è verificato un errore con l'upload\n\nPer favore prova a ridimensionare l'immagine prima di inviarla, è troppo grande!");
					document.querySelector("#uploadField").value = "";
				}
				
				// Dave: non è bello che ancora serva...
				Shark.render();

				waitBoxComponent.close();
			});
		}
		else {
			alert("Devi selezionare un file");
		}
	}
}

const imageContentView = new ImageContentView();

Shark.registerView(imageContentView);

export default imageContentView;
